export const API_ROUTES = {
    AUTH: {
        LOGIN: "/tenant-login",
        REGISTER: "/tenant-registration"
    },
    DOCTOR: "/doctor",
    FIRM: "/firm",
    EMPLOYEE: "/employee",
    MASTER: {
        DESIGNATION: "/designation",
        COUNTRY: "/country",
        ZONE: "/zone",
        HEADQUARTER: "/headquarter",
        LOCATION: "/location",
        SALT: "/master/salt",
        MEDICINE: "/master/medicine",
        ROUTE: "/master/route",
        SFC: "/master/sfc",
        DAILY_ALLOWANCE: "/master/daily-allowance",
    },
    USER: "/user",
    CHANGE_PASSWORD: "/user/change-password",
    HEADQUARTER_BY_TENANT_ZONE: "/headquarter-by-tenant-zone",
    SPECIALIZATION: "/specialization",
    DOCTOR_CATEGORY: "doctor-category",
    ASSIGN_ROLE_TO_EMPLOYEE: "/user-role-assign",
    UPLINE_MANAGER: "/upline-manager",
    HOLIDAY: "/holiday",
    VISIT: {
        DOCTOR: "/doctor-visits",
        FIRM: "/firm-visits"
    },
    TOUR_PLAN: "/tour-plans",
    TOUR_PLAN_UPDATE: "/update-tour-plan",
    LOCATION_BY_EMPLOYEE: "/location-by-employee",
    LEAVE: "/leaves",
    LEAVES_BY_EMP: "/leave-by-employee",
    LEAVE_UPDATE: "/update-leave",
    TOUR_PLAN_BY_EMP: "/tour-plans-by-employee",
    DEVIATION: "/deviation",
    DOWNLINE: "/downline/employee",
    EXPENSE: "/expense",
    REPORTS: {
        CALL_REPORT:             "/reports/call-report",
        CALL_REPORT_DETAILS:     "/reports/call-report/visit-details",
        MISSED_CALL_REPORT:      "/reports/missed-call-report",
        VISIT_TRACKER:           "/reports/visit-tracker",
        ATTENDANCE:              "/reports/attendance",
        SUBORDINATE_ATTENDANCE:  "/reports/subordinate-attendance",
        ALL_EMPLOYEE_ATTENDANCE: "/reports/all-employee-attendance",
    },
}